import { useSelector } from 'react-redux';
import { selectPermissionsByResource } from '@features/auth/slice';

/**
 * UI permission check. The user-service authorization decision is still
 * authoritative — this only governs what's visible in the UI.
 * Returns true when the current user's role grants `action` on `resource`.
 */
export function usePermission(resource: string, action: string): boolean {
  const index = useSelector(selectPermissionsByResource);
  return index[resource]?.has(action) ?? false;
}
